import * as React from "react";
import type { SVGProps } from "react";
const SvgNorwegian = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 48 48"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#E5212D"
      d="M46.728 16.5c-.495 1.083-1.602 2.362-3.283 3.802l-3.629 3.109-.038.032 4.52 7.859a.744.744 0 0 1-.112.886l-.662.678-7.246-4.74 1.558-2.283-.488-.318-3.498 2.997c-3.587 3.063-7.612 4.828-10.507 4.617-1.17-.086-2.075-.49-2.69-1.196-1.707-1.95-.713-5.82 2.483-9.64l.376.245c-1.692 2.308-2.134 4.52-1.13 5.65q.601.688 1.677.768c1.773.134 4.277-1.014 6.697-3.068l.902-.792-11.133-7.283.698-.598a1.88 1.88 0 0 1 1.803-.354l15.49 5.102.575-.492c-1.15-.767-2.216-2.142-1.866-3.396l2.543-2.177a7.2 7.2 0 0 1 2.747-1.466 7.3 7.3 0 0 1 2.555-.265c.82.068 1.505.295 1.74.585.14.17.414.674-.077 1.744h.003zM1.014 33.157h4.862v-9.702c0-2.486 1.344-3.951 3.552-3.951 2.207 0 3.24 1.362 3.24 3.88v9.77h4.862V22.569c0-4.597-2.69-7.523-6.965-7.523-2.103 0-3.792.75-4.794 2.147v-1.738H1.014v17.702"
    />
  </svg>
);
export default SvgNorwegian;
